module.exports = __webpack_public_path__ + "static/img/UTSC教室_1.85f3635.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTSC/UTSC教室_1.png
// module id = 40on
// module chunks = 0